import { r as registerInstance, h, H as Host } from './index-83f2275b.js';
var amplifyContainerCss = "amplify-container{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:100vh}";
var AmplifyContainer = /** @class */ (function () {
    function AmplifyContainer(hostRef) {
        registerInstance(this, hostRef);
    }
    AmplifyContainer.prototype.componentWillLoad = function () {
        console.warn('Version `1.x` of Amplify UI has been deprecated and will be removed in a future major version of `aws-amplify`. Please visit https://ui.docs.amplify.aws/ for the current version of Amplify UI.');
    };
    AmplifyContainer.prototype.render = function () {
        return (h(Host, null, h("slot", null)));
    };
    return AmplifyContainer;
}());
AmplifyContainer.style = amplifyContainerCss;
export { AmplifyContainer as amplify_container };
